import parser from "html-react-parser";
import { MutableRefObject } from "react";

import { handleDesignStyle, handleH2Size } from "@/utils/BlockTextImage";

export default function renderTitleTag(
  HtagLevel: number,
  styles: {
    readonly [key: string]: string;
  },
  isHero: boolean,
  asBackgroundDegrade: boolean,
  title: string,
  isH2AlternativeSize: boolean,
  sectionName: string,
  titleRef: MutableRefObject<any>
) {
  switch (HtagLevel) {
    case 1:
      return (
        <h1
          ref={titleRef}
          id="hero-title"
          className={`${sectionName}--title ${
            styles._title
          } ${handleDesignStyle(isHero, asBackgroundDegrade, styles)}`}
        >
          {parser(title)}
        </h1>
      );
    case 2:
      return (
        <h2
          ref={titleRef}
          className={`${sectionName}--title ${styles._title} ${handleH2Size(
            isH2AlternativeSize,
            styles
          )} ${handleDesignStyle(isHero, asBackgroundDegrade, styles)}`}
        >
          {parser(title)}
        </h2>
      );
    case 3:
      return (
        <h3
          ref={titleRef}
          className={`${sectionName}--title ${
            styles._title
          } ${handleDesignStyle(isHero, asBackgroundDegrade, styles)}`}
        >
          {parser(title)}
        </h3>
      );
  }
}
